import { useEffect, useState } from "react";

const useNewsScroll = (activePointNews) => {
    const [isNewsActive, setIsNewsActive] = useState(false);
    useEffect(() => {
        const scrollWindow = () => {
            const apNews = activePointNews;
            let scroll = 0;
            scroll = window.scrollY;
            if (apNews <= scroll) {
                setIsNewsActive(true);
            } else {
                setIsNewsActive(false);
            }
        };

        window.addEventListener("scroll", scrollWindow);
        return () => {
            window.removeEventListener("scroll", scrollWindow);
        };
    }, [activePointNews]);
    return { isNewsActive };
};

export default useNewsScroll;
